import React from 'react';
import { CloudUploadIcon, WifiOffIcon } from 'lucide-react';
import { useSyncStatus } from '../../../hooks/useSyncStatus';

/** Vises kun, når der ingen forbindelse er, eller ændringer endnu ikke er bekræftet. */
export function SyncStatusBar() {
  const {
    online,
    unsynced
  } = useSyncStatus();
  if (online && !unsynced) return null;
  return <p role="status" className="flex items-center gap-2 border-b border-line bg-canvas-deep px-4 py-2 text-sm text-ink-soft md:px-8" data-id="element-612" data-mp="38hxb65zzcjb1">
      {online ? <>
          <CloudUploadIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-613" data-mp="4zwwy93tzhoz" />
          Ikke synkroniseret endnu — gemmer …
        </> : <>
          <WifiOffIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-614" data-mp="3rgjbhinoa6dw" />
          Ingen forbindelse. {unsynced ? 'Dine ændringer er ikke synkroniseret endnu og gemmes automatisk.' : 'Data opdateres, når forbindelsen er tilbage.'}
        </>}
    </p>;
}